import * as React from "react";
import type { SVGProps } from "react";
const SvgSnowboarder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#snowboarder_svg__a)">
      <path d="M13.66 22.95h-.23a5.6 5.6 0 0 1-2.51-1.4l-8.67-8.7a4.28 4.28 0 0 1-1.23-2.39 1 1 0 0 1 1.97-.34c.078.5.313.962.67 1.32l8.68 8.7c.44.41.97.71 1.55.87a1 1 0 0 1 .74 1.2 1 1 0 0 1-.97.74" />
      <path d="M9.68 19.34a1 1 0 0 1-.56-.17 1 1 0 0 1-.27-1.38l2.84-4.26a1 1 0 0 1 1.35-.31l.18.12a1.21 1.21 0 0 0 1.23 0 1.2 1.2 0 0 0 .62-1.06V8.74a1 1 0 0 1 1.23-.97l2.73.62 1.86-1.86a1 1 0 0 1 1.639.325 1 1 0 0 1-.219 1.095l-2.25 2.25a1 1 0 0 1-.93.27L17.07 10v2.28a3.19 3.19 0 0 1-1.63 2.8 3.2 3.2 0 0 1-2.57.27l-2.36 3.6a1 1 0 0 1-.83.39M11.85 8.25H9.6a1.1 1.1 0 0 1-.32 0L7.03 7.5a1 1 0 0 1 .63-1.9l2.1.7h2.09a1 1 0 0 1 1 1 1 1 0 0 1-1 .95" />
      <path d="M5.92 15.64a1 1 0 0 1-.59-.19 1 1 0 0 1-.21-1.4l3-4.12a1 1 0 0 1 1.25-.3l2.85 1.42a1 1 0 0 1 .44 1.35 1 1 0 0 1-1.34.44l-2.09-1-2.54 3.44a1 1 0 0 1-.77.36M14.65 7.26a2.78 2.78 0 0 1-2.78-2.77v-.71A2.79 2.79 0 0 1 14.65 1a2.79 2.79 0 0 1 2.78 2.78v.71a2.78 2.78 0 0 1-2.78 2.77m0-4.26a.78.78 0 0 0-.78.78v.71a.77.77 0 0 0 .78.77.77.77 0 0 0 .78-.77v-.71a.78.78 0 0 0-.78-.78" />
    </g>
    <defs>
      <clipPath id="snowboarder_svg__a">
        <path fill="#fff" d="M1 1h21.6v21.9H1z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSnowboarder;
